import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Kennzahl-Kachel (nach STARK): Label, große Zahl, Fußnote. `accent` = die eine betonte Kachel. */
export function Metric({
  label,
  value,
  hint,
  icon: Icon,
  accent = false,
  tone,
  onClick,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  icon?: LucideIcon;
  accent?: boolean;
  tone?: "warning";
  onClick?: () => void;
}) {
  const Comp = onClick ? "button" : "div";
  return (
    <Comp
      onClick={onClick}
      className={cn(
        "flex flex-col gap-3 rounded-xl border bg-card p-4 text-left transition-colors",
        accent && "border-transparent bg-brand-soft text-brand-ink",
        onClick && "hover:border-foreground/20",
      )}
    >
      <div className={cn("flex items-center justify-between text-[13px] text-muted-foreground", accent && "text-brand-ink/80")}>
        <span>{label}</span>
        {Icon && <Icon className={cn("size-4", tone === "warning" && "text-warning")} />}
      </div>
      <div className="tabular text-3xl font-semibold tracking-tight">{value}</div>
      {hint && <div className={cn("text-xs text-muted-foreground", accent && "text-brand-ink/70")}>{hint}</div>}
    </Comp>
  );
}
